import React, { useEffect, useRef, useState } from "react";
import ApexCharts from "apexcharts";

const PieChart = ({ data = [], Jenis }) => { // Inisialisasi data dengan array kosong
    const [isActive, setIsActive] = useState(false);
    const chartRef = useRef(null);

    const toggleSwitch = () => {
        setIsActive(!isActive);
    };

    // Hitung persentase untuk setiap kategori
    const calculatePercentages = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            return [];
        }
        const total = data.reduce((sum, item) => sum + item.total, 0);
        return data.map(item => ({
            ...item,
            percentage: Math.round((item.total / total) * 100)
        }));
    };

    useEffect(() => {
        if (chartRef.current && Array.isArray(data) && data.length > 0) {
            const percentages = calculatePercentages(data);

            const labels = isActive
                ? percentages.map(item => `${item.percentage}% ${item.katSim}`)
                : data.map(item => `${new Intl.NumberFormat('id-ID').format(item.total)} ${item.katSim}`);

            const colors = data.map(item => item.color);

            const options = {
                series: data.map(item => item.total),
                chart: {
                    type: "pie",
                    width: 400,
                },
                labels: labels,
                colors: colors,
                responsive: [
                    {
                        breakpoint: 400,
                        options: {
                            chart: {
                                width: 480,
                            },
                            legend: {
                                position: "center",
                            },
                        },
                    },
                ],
            };

            const chart = new ApexCharts(chartRef.current, options);
            chart.render();

            return () => {
                chart.destroy();
            };
        }
    }, [data, isActive]);

    return (
        <div className="bg-gray-300/40 rounded-[10px] p-4 text-gray-700 md:w-full">
            <div className="flex justify-between items-center">
                <div className="flex flex-col">
                    <span className="font-semibold text-md">{Jenis}</span>
                    <span className="font-medium text-xs">Pemohon Psikologi {Jenis}</span>
                </div>
                <div className="flex items-center space-x-3">
                    <button
                        onClick={toggleSwitch}
                        className={`w-12 h-6 flex items-center rounded-full px-1 py-2 transition duration-300 ${isActive ? "bg-green-500" : "bg-gray-400"}`}
                    >
                        <div className={`w-5 h-5 bg-white rounded-full shadow-md transform transition ${isActive ? "translate-x-5" : "translate-x-0"}`} ></div>
                    </button>
                </div>
            </div>
            <div className="flex flex-col md:flex-row">
                <div className="flex justify-center items-center w-full p-2">
                    {Array.isArray(data) && data.length > 0 ? (
                        <div ref={chartRef} className=""></div>
                    ) : (
                        <p className="text-gray-600">Tidak ada data yang tersedia.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PieChart;